import { loginCtrl, protectedCtrl, registerCtrl } from '@/controllers/auth'
import {
  accessTokenVerification,
  validateLogin,
  validateRegister,
} from '@/middlewares'
import { Router } from 'express'

const router = Router()

router.post('/register', validateRegister, registerCtrl)

router.post('/', validateLogin, loginCtrl)

router.get('/protected', accessTokenVerification, protectedCtrl)

export default router
